import { useContext } from 'react'

import IframeMessageStoreContext from 'contexts/IframeMessageStoreContext'

const useIframeMessageStore = () => useContext(IframeMessageStoreContext)

export default useIframeMessageStore
